import { render } from "./RegisterEvent.vue?vue&type=template&id=9c850618&scoped=true"
import script from "./RegisterEvent.vue?vue&type=script&lang=js"
export * from "./RegisterEvent.vue?vue&type=script&lang=js"

import "./RegisterEvent.vue?vue&type=style&index=0&id=9c850618&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/eventos-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c850618"]])

export default __exports__